import { useDefaultListRouteQuery, useSelectedEntityRouteQuery } from './default';

export function useGotoProfile() {
  const { param: selectedList, setValue: setSelectedListProperties } = useDefaultListRouteQuery();
  const { setValue: setSelectedEntity } = useSelectedEntityRouteQuery();

  const gotoUserProfile = (userUid: string) => {
    if (selectedList.value !== 'users') {
      setSelectedListProperties('users');
    }
    setSelectedEntity(userUid);
  };

  const gotoGroupProfile = (groupUid: string) => {
    if (selectedList.value !== 'groups') {
      setSelectedListProperties('groups');
    }
    setSelectedEntity(groupUid);
  };

  return {
    gotoUserProfile,
    gotoGroupProfile,
  };
}
